<div class="w-full h-full flex flex-col">
  <!-- Header da Avaliação -->
  <app-lesson-header
    icon="bi-clipboard-check"
    iconColor="text-blue-500"
    [title]="headerTitle"
    [subtitle]="headerSubtitle"
    align="start"
    [wrapText]="true"
  >
  </app-lesson-header>

  <!-- Formulário de Edição -->
  <div class="flex-1 min-h-0 overflow-y-auto p-6">
    <!-- Se há uma questão selecionada, mostrar formulário de edição inline -->
    @if (currentQuestion && module?.contentType === 'evaluations') {
    <div>
      <app-question-form
        [question]="currentQuestion"
        [isEditMode]="true"
        (save)="onQuestionSave($event)"
        (canceled)="onQuestionCancel()"
      >
      </app-question-form>

      <div
        class="flex justify-between items-center pt-4 mt-4 border-t border-gray-200 dark:border-neutral-700"
      >
        <button type="button" class="btn-danger" (click)="onDelete()">
          <i class="bi bi-trash mr-2"></i>
          Excluir Questão
        </button>
      </div>
    </div>
    }

    <!-- Se não há questão selecionada ou é módulo de lições, mostrar lista de questões -->
    @if (!currentQuestion || module?.contentType !== 'evaluations') {
    <form
      [formGroup]="evaluationForm"
      (ngSubmit)="onSave()"
      class="flex flex-col gap-6 h-full"
    >
      <div class="grid grid-cols-1 lg:grid-cols-1 gap-6">
        <div class="lg:col-span-1 space-y-6 w-full">
          <div class="space-y-4">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                Questões
              </h3>
            </div>

            @if (showQuestionForm()) {
            <div class="mb-4">
              <app-question-form
                [question]="editingQuestion() || null"
                [isEditMode]="!!editingQuestion()"
                (save)="onQuestionSave($event)"
                (canceled)="onQuestionCancel()"
              >
              </app-question-form>
            </div>
            }

            <div class="space-y-3">
              @if (questions.length > 0) { @for (question of questions; track
              question.id) {
              <div class="content-card p-4">
                <div class="flex items-start justify-between">
                  <div class="flex-1">
                    <div class="flex items-center gap-2 mb-2">
                      <span
                        class="text-sm font-medium text-gray-700 dark:text-neutral-300"
                      >
                        Questão {{ question.order + 1 }}
                      </span>
                      <span
                        class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-neutral-700 text-gray-600 dark:text-neutral-300"
                      >
                        {{ question.type === 'single-choice' ? 'Seleção Única' :
                        question.type === 'multiple-choice' ? 'Seleção Múltipla'
                        : question.type === 'boolean' ? 'Verdadeiro/Falso' : ''
                        }}
                      </span>
                      <span
                        class="rounded bg-[var(--color-primary-soft)] px-2 py-0.5 text-xs text-[var(--color-primary)]"
                      >
                        {{ question.points }} ponto{{ question.points !== 1 ?
                        's' : '' }}
                      </span>
                    </div>
                    <p class="text-sm text-gray-900 dark:text-white mb-3">
                      {{ question.text }}
                    </p>
                    <div class="space-y-1">
                      @for (option of question.options; track option.id) {
                      <div class="text-sm text-gray-600 dark:text-neutral-300">
                        <span class="font-medium">{{ option.label }}.</span> {{
                        option.text }} @if
                        (question.correctAnswers.includes(option.id)) {
                        <span class="ml-2 text-green-600 dark:text-green-400">
                          <i class="bi bi-check-circle-fill"></i>
                        </span>
                        }
                      </div>
                      }
                    </div>
                  </div>
                  <div class="flex items-center gap-2 ml-4">
                    <button
                      type="button"
                      class="p-2 text-gray-600 hover:text-blue-600 dark:text-neutral-400 dark:hover:text-blue-400"
                      (click)="editQuestion(question)"
                      title="Editar questão"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      type="button"
                      class="p-2 text-gray-600 hover:text-red-600 dark:text-neutral-400 dark:hover:text-red-400"
                      (click)="deleteQuestion(question.id)"
                      title="Excluir questão"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              } } @else {
              <div class="text-center py-12 content-card">
                <i
                  class="bi bi-clipboard text-4xl text-gray-400 dark:text-neutral-500 mb-2 block"
                ></i>
                <p class="text-sm text-gray-500 dark:text-neutral-400">
                  Nenhuma questão adicionada ainda
                </p>
                <p class="text-xs text-gray-400 dark:text-neutral-500 mt-1">
                  Clique em "Adicionar Questão" para começar
                </p>
              </div>
              }
            </div>
          </div>
        </div>

        <div class="lg:col-span-1 hidden">
          <div class="sticky top-4 space-y-4">
            <div class="content-card p-4">
              <h3
                class="text-sm font-semibold text-gray-900 dark:text-white mb-3"
              >
                Resumo
              </h3>
              <div class="space-y-2 text-sm">
                <div class="flex justify-between">
                  <span class="text-gray-600 dark:text-neutral-400"
                    >Total de Questões:</span
                  >
                  <span class="font-medium text-gray-900 dark:text-white"
                    >{{ questions.length }}</span
                  >
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600 dark:text-neutral-400"
                    >Pontos Totais:</span
                  >
                  <span class="font-medium text-gray-900 dark:text-white"
                    >{{ totalPoints }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-neutral-700"
      >
        <button type="button" class="btn-danger" (click)="onDelete()">
          <i class="bi bi-trash mr-2"></i>
          {{ module ? 'Excluir Questão' : 'Excluir Lição' }}
        </button>
        <button
          type="submit"
          class="btn-primary"
          [disabled]="questions.length === 0"
        >
          Salvar Avaliação
        </button>
      </div>
    </form>
    }
  </div>
</div>
